/**
 * @nanokart/tryon-studio-sdk
 * Host Adapters - Public exports
 */

export * from './types';
export { DefaultHostAdapter } from './DefaultHostAdapter';
export { ShopifyHostAdapter } from './ShopifyHostAdapter';

// ============================================================================
// Adapter Factory
// ============================================================================

import { PlatformContext } from '../../types/config';
import { HostAdapter, HostAdapterCallbacks } from './types';
import { DefaultHostAdapter } from './DefaultHostAdapter';
import { ShopifyHostAdapter } from './ShopifyHostAdapter';

export interface CreateHostAdapterOptions {
  platformContext: PlatformContext;
  callbacks?: HostAdapterCallbacks;
  communicationMode?: 'direct' | 'postMessage';
  targetOrigin?: string;
}

/**
 * Create appropriate host adapter based on platform context
 */
export function createHostAdapter(options: CreateHostAdapterOptions): HostAdapter {
  const { platformContext, callbacks = {}, communicationMode, targetOrigin } = options;

  switch (platformContext) {
    case 'shopify':
      return new ShopifyHostAdapter(callbacks);

    case 'woocommerce':
    case 'magento':
    case 'custom':
    case 'standalone':
    default:
      return new DefaultHostAdapter(callbacks, { communicationMode, targetOrigin });
  }
}
